module.exports = __webpack_public_path__ + "img/but.be5030ca.webp";